import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getUserProfile, getUserStats } from '../../services/userProfile';
import { User, Award } from 'lucide-react';
import '../../styles/Header.css';
const Header = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);
  const [userPoints, setUserPoints] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadUserPoints = async () => {
      if (user) {
        // أولاً نجلب معلومات المستخدم للحصول على رقم الهاتف
        const profileResult = await getUserProfile(user.id);
        if (profileResult.status === 'success' && profileResult.data.phone) {
          // ثم نستخدم رقم الهاتف لحساب النقاط من الطلبات المكتملة
          const statsResult = await getUserStats(profileResult.data.phone);
          if (statsResult.status === 'success') {
            setUserPoints(statsResult.data.points || 0);
          }
        }
      }
    };

    loadUserPoints();
  }, [user]);

  // إضافة مستمع لإغلاق القائمة عند النقر في أي مكان
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    // Initialize header state

    let ticking = false;
    let lastY = window.scrollY;
    let lastTime = performance.now();

    const updateHeader = () => {
      const currentY = window.scrollY;
      const now = performance.now();
      const deltaY = currentY - lastY;
      const deltaTime = now - lastTime;
      const velocity = Math.abs(deltaY) / (deltaTime || 1);

      // Show header if scrolling up or near top
      if (currentY < lastY || currentY < 50) {
        setIsVisible(true);
      } else if (currentY > lastY && currentY > 50 && velocity > 0.1) {
        setIsVisible(false);
      }

      setLastScrollY(currentY);
      lastY = currentY;
      lastTime = now;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <header 
      className={`header ${lastScrollY > 50 ? 'scrolled' : ''} ${!isVisible ? 'header-hidden' : ''}`} 
      id="header"
    >
      <div className="header-content">
        {/* Logo Section */}
        <div className="logo-section">
          <Link to="/" className="logo" title="الرئيسية">
            <img src="/logo512.png" alt="زد للتوصيل" className="logo-image" style={{ height: '40px', width: 'auto' }} />
          </Link>
        </div>

        {/* Navigation Section */}
        <nav className="nav-section">
          <Link to="/" className="nav-link">الرئيسية</Link>
          <Link to="/order" className="nav-link">اطلب الآن</Link>
          {user && <Link to="/profile" className="nav-link">حسابي</Link>}
          {user && <Link to="/join" className="nav-link">انضم إلينا</Link>}
          
        </nav>

        {/* User Section */}
        <div className="user-section">
          {user ? (
            <>
              <div className="user-points">
                <Award size={16} className="text-yellow-400" />
                <span>{userPoints}</span>
                <span className="text-blue-200">نقطة</span>
              </div>
              <button 
                onClick={() => navigate('/profile')}
                className="profile-button"
              >
                <User size={18} />
                <span className="hide-sm">حسابي</span>
              </button>
            </>
          ) : (
            <Link to="/auth" className="profile-button">
              <User size={18} />
              <span className="hide-sm">تسجيل الدخول</span>
            </Link>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="menu-button"
          onClick={(e) => {
            e.stopPropagation();
            setIsMobileMenuOpen(!isMobileMenuOpen);
          }}
        >
          <span className="material-icons">
            {isMobileMenuOpen ? 'close' : null}
          </span>
        </button>
      </div>

      {/* Mobile Navigation */}
      <nav className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
        <Link to="/" className="nav-link">الرئيسية</Link>
        <Link to="/order" className="nav-link">اطلب الآن</Link>
        {user && <Link to="/join" className="nav-link">انضم إلينا</Link>}
        {user ? (
          <Link to="/profile" className="nav-link">حسابي</Link>
        ) : (
          <>
            <Link to="/auth" className="nav-link">تسجيل الدخول</Link>
            <Link to="/join" className="nav-link">انضم إلينا</Link>
          </>
        )}
      </nav>
    </header>
  );
};

export default Header;
